import TodoCategoryService from '@/services/TodoCategoryService'

const state = {
  todoCategories: [],
  todoCategoriesPag: {
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
    sortDesc: []
  }
}

const getters = {
  TODO_CATEGORIES: state => state.todoCategories,
  TODO_CATEGORIES_PAG: state => state.todoCategoriesPag
}

const mutations = {
  SET_TODO_CATEGORIES (state, todoCategories) {
    state.todoCategories = todoCategories
  },

  SET_TODO_CATEGORIES_PAG (state, todoCategoriesPag) {
    state.todoCategoriesPag = todoCategoriesPag
  },

  ADD_TODO_CATEGORY (state, todoCategory) {
    state.todoCategories.push(todoCategory)
  },

  UPDATE_TODO_CATEGORY (state, updatedCategory) {
    const index = state.todoCategories.findIndex(c => c.id === updatedCategory.id)
    if (index !== -1) {
      state.todoCategories.splice(index, 1, updatedCategory)
    }
  },

  DELETE_TODO_CATEGORY (state, id) {
    const index = state.todoCategories.findIndex(c => c.id === id)
    if (index !== -1) {
      state.todoCategories.splice(index, 1)
    }
  }
}

const actions = {
  async LOAD_TODO_CATEGORIES ({ commit, state }, params = {}) {
    try {
      const pagination = state.todoCategoriesPag
      const requestParams = {
        page: pagination.page,
        per_page: pagination.itemsPerPage,
        ...params
      }

      // Agregar ordenamiento si existe
      if (pagination.sortBy.length > 0) {
        requestParams.sort_by = pagination.sortBy[0]
        requestParams.sort_desc = pagination.sortDesc[0] ? 1 : 0
      }

      const response = await TodoCategoryService.get(requestParams)

      if (response.data && response.data.data) {
        // Soporta respuesta paginada o directa
        let categories = []
        let total = 0

        if (Array.isArray(response.data.data.data)) {
          // Respuesta paginada
          categories = response.data.data.data
          total = response.data.data.total || categories.length
        } else if (Array.isArray(response.data.data)) {
          // Respuesta directa
          categories = response.data.data
          total = categories.length
        }

        commit('SET_TODO_CATEGORIES', categories)
        return total
      }

      return 0
    } catch (error) {
      console.error('Error al cargar categorías de to-do:', error)
      throw error
    }
  },

  async CREATE_TODO_CATEGORY ({ commit }, data) {
    try {
      const response = await TodoCategoryService.post(data)
      
      if (response.data && response.data.data) {
        commit('ADD_TODO_CATEGORY', response.data.data)
        return response.data.data
      }
      
      throw new Error('Respuesta inválida del servidor')
    } catch (error) {
      console.error('Error al crear categoría de to-do:', error)
      throw error
    }
  },

  async UPDATE_TODO_CATEGORY ({ commit }, data) {
    try {
      const response = await TodoCategoryService.put(data)
      
      if (response.data && response.data.data) {
        commit('UPDATE_TODO_CATEGORY', response.data.data)
        return response.data.data
      }
      
      throw new Error('Respuesta inválida del servidor')
    } catch (error) {
      console.error('Error al actualizar categoría de to-do:', error)
      throw error
    }
  },

  async DELETE_TODO_CATEGORY ({ commit }, id) {
    try {
      await TodoCategoryService.delete(id)
      commit('DELETE_TODO_CATEGORY', id)
      return true
    } catch (error) {
      console.error('Error al eliminar categoría de to-do:', error)
      throw error
    }
  },

  async VIEW_TODO_CATEGORY ({ commit }, id) {
    try {
      const response = await TodoCategoryService.view({ id })
      
      if (response.data && response.data.data) {
        return response.data.data
      }
      
      throw new Error('Respuesta inválida del servidor')
    } catch (error) {
      console.error('Error al ver categoría de to-do:', error)
      throw error
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
